import callApi from "@web-monorepo/infra/callApi";
import createAsyncActions from "@web-monorepo/infra/createAsyncActions";
import type { AnyAction } from "redux";
import { takeEvery, call, put } from "redux-saga/effects";
import { Response } from "superagent";
import { getApiHost } from "src/infra/getHost";

type FetchFeatureSwitchesPayload = {
  teacherId: string;
};

export const [FETCH_FEATURE_SWITCHES, FETCH_FEATURE_SWITCHES_DONE] = createAsyncActions("auth/feature_switches");

const basePath = getApiHost();
export const FEATURE_SWITCHES: string[] = [];

export const createAction = (payload: FetchFeatureSwitchesPayload) => ({
  type: FETCH_FEATURE_SWITCHES,
  payload,
});

export function* saga() {
  yield takeEvery(FETCH_FEATURE_SWITCHES, fetchFeatureSwitches);
}
function* fetchFeatureSwitches({ payload }: { type: string; payload: FetchFeatureSwitchesPayload }) {
  if (!FEATURE_SWITCHES.length) return;

  const { teacherId } = payload;
  const res: Response = yield call(callApi, {
    path: `${basePath}/api/featureSwitch`,
    query: { teacherId, teacherSwitches: FEATURE_SWITCHES.join(",") },
  });

  yield put({
    type: FETCH_FEATURE_SWITCHES_DONE,
    payload: {
      ...payload,
      body: res.body,
      ok: res.ok,
    },
  });
}

export function reducer(state: Record<string, unknown>, action: AnyAction) {
  if (action.type === FETCH_FEATURE_SWITCHES_DONE && action.payload.ok) {
    const switches = action?.payload?.body?.teacher;
    return {
      ...state,
      switches,
    };
  }

  return state;
}
